<template>
    <div class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información</div>
    </div>
</template>

<script>
    import { EncryptService } from '@/services/EncryptService';
    export default {
        name: 'IsabelleConnection',
        async created() {

            const PHONE = this.$route.params.phone;
            const TOKEN = localStorage.getItem('TOKEN');
            
            if (TOKEN === null || TOKEN === undefined || TOKEN === '') {
                
                localStorage.removeItem('ID')
                localStorage.removeItem('TIPO')
                localStorage.removeItem('TOKEN')
                localStorage.removeItem('DESPACHO')
                localStorage.removeItem('USERNAME')
                localStorage.removeItem('NAME')
                localStorage.removeItem('LAST_NAME')
                localStorage.removeItem('TIPO_CARTERA');
                sessionStorage.setItem('ISABELLE_PHONE', PHONE);
                this.$router.push('/login');
                return;
            }

            const ISABELLE_PHONE = sessionStorage.getItem('ISABELLE_PHONE')
            if (ISABELLE_PHONE !== null || ISABELLE_PHONE !== undefined || ISABELLE_PHONE !== '') {
                sessionStorage.removeItem('ISABELLE_PHONE')
            }

            const PARAMS = {
                tipo: 3,
                dato: PHONE
            }
            const STR_PARAM = JSON.stringify(PARAMS);
            const ENC_PARAM = await EncryptService.encrypt(STR_PARAM);
            const URL = `/SGCCV/search-management/${ENC_PARAM}`;
            this.$router.push(URL);
        }
    }
</script>